module.exports = __webpack_public_path__ + "static/media/wangzhangweihuliucheng.be7d540c.png";